import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/categories';
import { getAllArticleSlugs, getArticleBySlug } from '@/mocks/articles';

export default function Footer() {
  const allSlugs = getAllArticleSlugs();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-lg"></i>
              </div>
              <span className="font-heading text-xl font-semibold text-foreground-950">
                {siteConfig.siteName}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {siteConfig.disclaimer}
            </p>
            <a
              href={siteConfig.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Visit {siteConfig.mainSiteName}
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              Popular Categories
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              SEO Guides
            </h4>
            <div className="flex flex-col gap-2">
              {allSlugs.map((s) => {
                const a = getArticleBySlug(s);
                return (
                  <Link
                    key={s}
                    to={`/article/${s}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                  >
                    {a?.badge || s}
                  </Link>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                Home
              </Link>
              <Link
                to="/article/superbuy-spreadsheet-guide"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                Complete Guide
              </Link>
              <Link
                to="/article/superbuy-spreadsheet-for-beginners"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                Beginner Tutorial
              </Link>
              <a
                href={siteConfig.mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                KASpreadsheet Main Site
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.siteName}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={siteConfig.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200 cursor-pointer"
            >
              Main Site
            </a>
            <Link
              to="/"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200"
            >
              Home
            </Link>
            <Link
              to="/article/superbuy-spreadsheet-safety-guide"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200"
            >
              Safety
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}